exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.divideContaner[data-v-3557e9b4] {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  background: #D9D9D9;\n}\n.divideContaner .divideImage[data-v-3557e9b4] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n", "", {"version":3,"sources":["D:/bojun/burgeon-UI/src/components/split-panel/divide.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,oBAAoB;CACrB;AACD;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;CACrB","file":"divide.vue","sourcesContent":["\n.divideContaner[data-v-3557e9b4] {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  background: #D9D9D9;\n}\n.divideContaner .divideImage[data-v-3557e9b4] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-3557e9b4","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/split-panel/divide.vue
// module id = 672
// module chunks = 0